<div class="skeleton-legal-document-container">
  <div class="h2--skeleton"></div>
  <p class="p--skeleton"></p>
  <div class="skeleton-legal-document-block"></div>
  <p class="p--skeleton"></p>
  <p class="p--skeleton"></p>
  <p class="p--skeleton"></p>
</div>
<div class="skeleton-legal-document-container">
  <div class="h2--skeleton"></div>
  <div class="skeleton-legal-document-block"></div>
  <p class="p--skeleton"></p>
</div>
<div class="skeleton-legal-document-container">
  <div class="h2--skeleton"></div>
  <div class="skeleton-legal-document-block"></div>
  <p class="p--skeleton"></p>
  <p class="p--skeleton"></p>
  <p class="p--skeleton"></p>
</div>
